import { FileReader, FileWriter } from '@/platform'
import FileName from './FileName'

class MusicItem {
    /**
     * 音乐的文件名
     */
    public Name: FileName = new FileName()

    /**
     * 音乐的音量
     */
    public Volume: number = 50

    constructor(param?: { name: FileName; volume: number } | FileReader) {
        if (param && 'name' in param) {
            const { name, volume } = param
            this.Name = name
            this.Volume = volume
        } else if (param instanceof FileReader) {
            this.readBin(param as FileReader)
        } else {
            this.Name = new FileName()
            this.Volume = 50
        }
    }

    readBin(reader: FileReader) {
        this.Name = new FileName()
        this.Name.readBin(reader)
        this.Volume = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        this.Name.writeBin(writer)
        writer.writeInt(this.Volume)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name.readVersionedOui(reader.readObj(reader.readInt()))
        this.Volume = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        this.Name.writeVersionedOui(writer)
        writer.writeInt(this.Volume)

        writer.writerLength()
    }
}

export default MusicItem
